import { request } from '../utils/request';

export const fetchSupportChatModuleTagsAPI = () =>
  request.get('/superadmin/support-chat-module-tags');

export const addSupportChatModuleTagAPI = data => {
  const { name, description, isActive } = data;
  return request.post('/superadmin/support-chat-module-tags', {
    name,
    description,
    isActive,
  });
};

export const updateSupportChatModuleTagAPI = data => {
  const { id, name, description, isActive } = data;
  return request.put(`/superadmin/support-chat-module-tags/${id}`, {
    name,
    description,
    isActive,
  });
};

export const deleteSupportChatModuleTagAPI = data =>
  request.delete(`/superadmin/support-chat-module-tags/${data.id}`);
